function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 253.175781 2.824219 C 233.546875 -3.722656 212.273438 1.300781 197.640625 15.933594 L 144.191406 69.382812 L 32.820312 21.65625 L 11.605469 42.867188 L 101.761719 111.808594 L 53.03125 160.539062 L 21.214844 149.933594 L 0 171.148438 L 53.03125 202.96875 L 84.851562 256 L 106.066406 234.785156 L 95.460938 202.96875 L 144.191406 154.238281 L 213.132812 244.394531 L 234.34375 223.179688 L 186.617188 111.8125 L 240.070312 58.359375 C 254.699219 43.726562 259.722656 22.453125 253.175781 2.824219 Z M 253.175781 2.824219 "
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 239.648438 133.023438 C 233.789062 127.164062 224.292969 127.164062 218.433594 133.023438 L 213.953125 137.507812 L 226.679688 167.207031 L 239.648438 154.238281 C 245.507812 148.378906 245.507812 138.882812 239.648438 133.023438 Z M 239.648438 133.023438 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M 122.976562 16.351562 C 117.117188 10.492188 107.621094 10.492188 101.761719 16.351562 L 88.792969 29.320312 L 118.492188 42.046875 L 122.976562 37.5625 C 128.835938 31.707031 128.835938 22.210938 122.976562 16.351562 Z M 122.976562 16.351562 "
});

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "white",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.446ddd69.svg";
export { ForwardRef as ReactComponent };